export const isWord = mime => {
  if (!mime) return false;
  if (mime.toLowerCase() === 'application/msword') return true;
  if (
    mime.toLowerCase() === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  )
    return true;
  return false;
};
export const isPdf = mime => mime && mime.toLowerCase() === 'application/pdf';
export const isExcel = mime => {
  if (!mime) return false;
  if (mime.toLowerCase() === 'application/vnd.ms-excel') return true;
  if (mime.toLowerCase() === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    return true;
  return false;
};
export const isEditable = (ext, mime) => {
  const includedExtensions = [
    'doc',
    'docx',
    'dot',
    'dotx',
    'dotm',
    'docm',
    'rtf',
    'xls',
    'xlsx',
    'xlsm',
  ];
  const includedMimeTypes = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.template.macroenabled.12',
    'application/vnd.ms-word.document.macroenabled.12',
    'application/rtf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  return (
    includedExtensions.includes(ext.toLowerCase()) || includedMimeTypes.includes(mime.toLowerCase())
  );
};

export default { isWord, isPdf, isEditable };
